import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="text-center p-5">Chargement...</div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    if (superAdminOnly && user.role !== 'superadmin') {
        return <Navigate to="/dashboard" />;
    }

    if (adminOnly && user.role !== 'admin' && user.role !== 'superadmin') {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default ProtectedRoute;
